export const ACCEPTED_DOCUMENT_FILE_TYPES = [
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'text/csv',
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xls
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'application/vnd.ms-outlook', // .msg
  'image/jpeg',
  'image/png',
  '',
] as const;

export const DOCUMENT_CATEGORIES = [
  'General',
  'Underwriting Submission',
  'Quotes - Correspondence',
  'Claims',
  'Invoices',
  'Cover Note',
  'Policies & Endorsements',
  'Internal Audit / Compliane',
  'Draft Documents',
] as const;
